exports.OptimizelyDataFilePaths = {
  QA: '/datafiles/GnyGx71RMLkBMy54SG1sMi.json',
  Production: '/datafiles/JSy82M5bxf9FFZUk3c9z7g.json',
};
